export const Marquee = () => {
  const words = [
    "MIGRATION IN PROGRESS",
    "NEW DOMAIN",
    "NEW FACE",
    "NEW EXPERIENCE",
    "XPDC.CO.ID",
  ];

  const Track = () => (
    <div className="flex shrink-0 items-center">
      {Array.from({ length: 3 }).map((_, g) =>
        words.map((w, i) => (
          <span
            key={`${g}-${i}`}
            className="mx-6 flex items-center font-mono-x text-2xl font-extrabold uppercase tracking-tight sm:text-3xl md:text-4xl"
          >
            {w}
            <span
              className="ml-12 inline-block h-2 w-2 rotate-45"
              style={{ background: "var(--xp-accent)" }}
            />
          </span>
        )),
      )}
    </div>
  );

  return (
    <section
      className="relative overflow-hidden border-b bp-border py-6"
      aria-hidden="true"
      data-testid="marquee-section"
      style={{ background: "var(--xp-primary)", color: "var(--xp-invert-text)" }}
    >
      <div className="flex w-max animate-marquee">
        <Track />
        <Track />
      </div>
    </section>
  );
};
